export default __webpack_public_path__ + "static/media/Upgrade_Premium.372d0485.JPG";